export default __webpack_public_path__ + "static/media/228.ec5eaee3.png";